export const checkNullFesabilityParameter = (data) => {
    for (const key in data) {
        if(data[key] === 0){
            return true;
        }
    }
    return false;
}